document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.products-block').forEach(block => {
		const tabs   = block.querySelectorAll('.products-block__tab');
		const panels = block.querySelectorAll('.products-block__panel');

		tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				const idx = tab.dataset.tab;

				tabs.forEach(t => {
					t.classList.remove('is-active');
					t.setAttribute('aria-selected', 'false');
				});
				panels.forEach(p => p.classList.remove('is-active'));

				tab.classList.add('is-active');
				tab.setAttribute('aria-selected', 'true');

				const panel = block.querySelector(`.products-block__panel[data-panel="${idx}"]`);
				if (panel) {
					// Неактивні вкладки приходять у <template> — розгортаємо при першому відкритті.
					const tpl = panel.querySelector(':scope > template');
					if (tpl) panel.replaceChild(tpl.content, tpl);
					panel.classList.add('is-active');
				}
			});
		});
	});
});
